/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateToJSON,
} from './JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    subsidyId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    subsidyDetailId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    relationship?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    degreeCount?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    ageType?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    priceType?: string;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate>}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    useDates?: Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDate>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation
     */
    couponId?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation {
    return JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subsidyId': !exists(json, 'subsidyId') ? undefined : json['subsidyId'],
        'subsidyDetailId': !exists(json, 'subsidyDetailId') ? undefined : json['subsidyDetailId'],
        'relationship': !exists(json, 'relationship') ? undefined : json['relationship'],
        'degreeCount': !exists(json, 'degreeCount') ? undefined : json['degreeCount'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'ageType': !exists(json, 'ageType') ? undefined : json['ageType'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'useDates': !exists(json, 'useDates') ? undefined : ((json['useDates'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateFromJSON)),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'couponId': !exists(json, 'couponId') ? undefined : json['couponId'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subsidyId': value.subsidyId,
        'subsidyDetailId': value.subsidyDetailId,
        'relationship': value.relationship,
        'degreeCount': value.degreeCount,
        'age': value.age,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'ageType': value.ageType,
        'priceType': value.priceType,
        'useDates': value.useDates === undefined ? undefined : ((value.useDates as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationUseDateToJSON)),
        'groupId': value.groupId,
        'couponId': value.couponId,
    };
}

